export default "__VITE_ASSET__mcvtE8Uj__"